import { Node_Type } from "./../ricos-types/index.js";
import { getHeadingInSelection } from "./../_shared/resolvers/get-heading-in-selection.js";
import { isAlwaysVisible } from "./../_shared/resolvers/is-always-visible.js";
import { isNodeOrCaptionSelected } from "./../_shared/resolvers/is-node-or-caption-selected.js";
import { isTextStylesMatchDocumentStylesResolver } from "./../_shared/resolvers/is-text-styles-match-document-styles.js";
import { TEXT_BUTTON_HEADINGS } from "./data-hooks.js";
import { getCurrentHeadingIcon } from "./dropdown/get-current-headings-icon.js";
import HeadingsDropdownLazy from "./dropdown/headings-dropdown-lazy.js";
const HEADINGS_MODAL_ID = `${Node_Type.HEADING}.modal`;
const getHeadingsIcon = (isCustomHeadings) => {
  return getCurrentHeadingIcon(isCustomHeadings);
};
const getTextButtons = (config) => {
  const isCustomHeadings = !!config?.allowHeadingCustomization;
  return [
    {
      id: `${Node_Type.HEADING}.dropdown`,
      type: "modal",
      presentation: {
        dataHook: TEXT_BUTTON_HEADINGS,
        tooltip: "FormattingToolbar_TextStyleButton_Tooltip",
        getIcon: getHeadingsIcon(isCustomHeadings)
      },
      attributes: {
        isStylesMatch: isTextStylesMatchDocumentStylesResolver,
        visible: isAlwaysVisible,
        selectedHeading: getHeadingInSelection,
        disabled: isNodeOrCaptionSelected
      },
      modal: {
        id: HEADINGS_MODAL_ID,
        Component: HeadingsDropdownLazy(isCustomHeadings ? 216 : 143)
      }
    }
  ];
};
export {
  getTextButtons
};
//# sourceMappingURL=getTextButtons.js.map
